
import { ref, nextTick, provide } from 'vue';
export default {
  setup() {
    //强制刷新
    const isRouterAlive = ref(true);
    const reload = () => {
      isRouterAlive.value = false;
      nextTick(function() {
        isRouterAlive.value = true;
      });
    };
    provide('reload', reload);
    return {
      isRouterAlive,
    };
  },
};
